const getHubspotQueue = () => {
  if (typeof window === 'undefined') return []
  // @ts-ignore
  window._hsq = window._hsq || []
  // @ts-ignore
  return window._hsq
}

const useHubspotTracking = () => {
  const _hsq = getHubspotQueue()

  const identify = (payload) => {
    _hsq.push(['identify', {
      ...payload
    }])
  }

  const trackPage = (path) => {
    _hsq.push(['setPath', path])
    _hsq.push(['trackPageView'])
  }

  return {
    _hsq,
    identify,
    trackPage
  }
}

export default useHubspotTracking
